"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _themeGet = require("@styled-system/theme-get");

var _ui = _interopRequireDefault(require("@emcasa/ui"));

var _Dropdown = require("@emcasa/ui/lib/components/Dropdown");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  z-index: 2;\n  position: absolute;\n  left: 0;\n  top: calc(100% + ", "px);\n  width: 100%;\n  overflow-y: auto;\n  max-height: ", "px;\n  pointer-events: ", ";\n  opacity: ", ";\n  transform: ", ";\n  transition: opacity ", " linear,\n    transform 0.5s cubic-bezier(0.4, 0.2, 0, 1),\n    max-height\n      ", ";\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: 8px;\n  box-shadow: 0 8px 14px rgba(131, 145, 165, 0.2);\n  margin: 0;\n  padding: 0;\n  &:focus {\n    outline: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var MAX_HEIGHT = _ui["default"].buttonHeight[0] * 4 + _ui["default"].buttonHeight[0] / 2;

var Listbox = _styledComponents["default"].ul(_templateObject(), (0, _themeGet.themeGet)('space.2'), function (_ref) {
  var focused = _ref.focused;
  return focused ? MAX_HEIGHT : '0';
}, function (_ref2) {
  var focused = _ref2.focused;
  return focused ? 'initial' : 'none';
}, function (_ref3) {
  var focused = _ref3.focused;
  return focused ? '1' : '0';
}, function (_ref4) {
  var focused = _ref4.focused;
  return focused ? 'translateY(0)' : 'translateY(-12px)';
}, function (_ref5) {
  var focused = _ref5.focused;
  return focused ? '0.2s' : '0.15s';
}, function (_ref6) {
  var focused = _ref6.focused;
  return focused ? '0s' : '0.5s cubic-bezier(0.4, 0.2, 0, 1)';
}, (0, _themeGet.themeGet)('colors.white'), (0, _themeGet.themeGet)('colors.grey300'));

var DropdownContainer =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(DropdownContainer, _PureComponent);

  function DropdownContainer() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, DropdownContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(DropdownContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onDocumentClick", function (e) {
      var _this$props = _this.props,
          focused = _this$props.focused,
          onDropdownBlur = _this$props.onDropdownBlur;
      var target = _this.targetDOMNode;

      if (focused && target && onDropdownBlur && target && !target.contains(e.target)) {
        onDropdownBlur();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onDocumentFocus", function (e) {
      var _this$props2 = _this.props,
          focused = _this$props2.focused,
          onDropdownBlur = _this$props2.onDropdownBlur,
          onDropdownFocus = _this$props2.onDropdownFocus;
      var target = _this.targetDOMNode;
      if (focused && target && !target.contains(e.target)) onDropdownBlur();else if (!focused && target && target.contains(e.target)) onDropdownFocus();
    });
    return _this;
  }

  (0, _createClass2["default"])(DropdownContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('touchend', this.onDocumentClick);
      document.addEventListener('focus', this.onDocumentFocus, true);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('touchend', this.onDocumentClick);
      document.removeEventListener('focus', this.onDocumentFocus, true);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          dropdownId = _this$props3.dropdownId,
          focused = _this$props3.focused;
      return _react["default"].createElement(Listbox, {
        id: "".concat(dropdownId, "list"),
        focused: focused,
        tabIndex: "-1",
        role: "listbox",
        "aria-label": "Lista"
      }, children);
    }
  }, {
    key: "targetDOMNode",
    get: function get() {
      return this.props.target ? _reactDom["default"].findDOMNode(this.props.target) : undefined;
    }
  }]);
  return DropdownContainer;
}(_react.PureComponent);

exports["default"] = DropdownContainer;
(0, _defineProperty2["default"])(DropdownContainer, "propTypes", _Dropdown.container.propTypes);